import { RootState } from 'modules/main/redux';
import { NotificationWithId } from '../types';

export const notificationsSelector = (state: RootState): NotificationWithId[] =>
  state.notifications.list;
